import { lazy } from 'react'

import type { RouteObject } from 'react-router'

import { DetalhesEmpreendimentoPage } from '@/features/empreendimentos/chile/pages/detalhes-empreendimento'
import { DetalhesEmpreendimentoPageSuspense } from '@/features/empreendimentos/chile/pages/detalhes-empreendimento/suspense'
import { EmpreendimentoMidiasPage } from '@/features/empreendimentos/chile/pages/empreendimento-midias'
import { EmpreendimentoMidiasPageSuspense } from '@/features/empreendimentos/shared/components/empreendimento-midias.suspense'

const EmpreendimentosPage = lazy(() =>
  import('@/features/empreendimentos/chile/pages/empreendimentos').then((module) => ({
    default: module.EmpreendimentosPage,
  })),
)

export const chileEmpreendimentosRoutes: RouteObject[] = [
  {
    path: 'es-CL/empreendimentos',
    children: [
      {
        index: true,
        element: <EmpreendimentosPage />,
      },
      {
        path: ':idExterno',
        element: (
          <DetalhesEmpreendimentoPageSuspense>
            <DetalhesEmpreendimentoPage />
          </DetalhesEmpreendimentoPageSuspense>
        ),
      },
      {
        path: ':idExterno/:midiaSelecionada',
        element: (
          <EmpreendimentoMidiasPageSuspense>
            <EmpreendimentoMidiasPage />
          </EmpreendimentoMidiasPageSuspense>
        ),
      },
    ],
  },
]
